module.exports = __webpack_public_path__ + "img/dosirak_main.4c7d1e4f.jpg";